import { h } from 'hyperapp'

export default () => h('span', { class: 'line-jump' })